<template>
	<v-container fluid >
		<v-toolbar elevation="1">
			<v-app-bar-nav-icon :to="{ name: 'Dictionaries' }">
				<v-icon large :color="color">{{ icon }}</v-icon>
			</v-app-bar-nav-icon>
			<v-toolbar-title>
				<div class="text-h6">{{ title }}</div>
				<div class="text-subtitle-2 font-weight-light">{{ subtitle }}</div>
			</v-toolbar-title>
			<v-spacer></v-spacer>
			<!-- <v-btn icon @click="search.brand.visible = !search.brand.visible">
				<v-icon>mdi-magnify</v-icon>
			</v-btn>
			<v-btn icon>
				<v-icon>mdi-plus</v-icon>
			</v-btn> -->
		</v-toolbar>
		<v-row class="mt-2">
			<v-col cols="12" md="2">
				<v-card :loading="loading.category" class="d-flex flex-column" max-height="85vh">
					<v-toolbar flat>
						<v-toolbar-title>Категорії</v-toolbar-title>
						<v-spacer></v-spacer>
						<!-- <v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn> -->
					</v-toolbar>
					<v-card-text class="flex-grow-1 overflow-y-auto">
						<v-list>
							<v-list-item-group v-model="category" active-class="indigo--text">
								<v-list-item v-for="(item, index) in categories" :key="index" @click="onCategory(item)">
									<v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar>

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle>
									</v-list-item-content>

									<!-- <v-list-item-action>
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon v-bind="attrs" v-on="on">
													<v-icon>mdi-dots-vertical</v-icon>
												</v-btn>
											</template>
											<v-list>
												
											</v-list>
										</v-menu>
									</v-list-item-action> -->
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card :loading="loading.brand" class="d-flex flex-column" max-height="85vh">
					<v-toolbar flat :extended="search.brand.visible">
						<v-toolbar-title>Марки</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="search.brand.visible = !search.brand.visible">
							<v-icon>mdi-magnify</v-icon>
						</v-btn>
						<!-- <v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn> -->

						<template v-slot:extension v-if="search.brand.visible">
							<v-text-field v-model="search.brand.text"
								hide-details
								single-line
								clearable
							></v-text-field>
							<!-- prepend-icon="mdi-magnify" -->
						</template>
					</v-toolbar>
					<!-- <v-card-text style="height: 300px; overflow-y: auto;"> -->
					<!-- <v-card-text style="overflow-y: auto;"> -->
					<v-card-text class="flex-grow-1 overflow-y-auto">
						<v-list>
							<v-list-item-group v-model="brand" active-class="green--text">
								<v-list-item v-for="(item, index) in filteredBrands" :key="index" @click="onBrand(item)">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
										 <v-list-item-subtitle>{{ item.yearFrom }} - {{ item.yearTo }}
											<v-chip v-if="item.isNew"
												class="ma-2"
												color="green"
												text-color="white"
												label
												x-small
											>
											New
											</v-chip>
										</v-list-item-subtitle>
									</v-list-item-content>

									<v-list-item-action>
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon v-bind="attrs" v-on="on">
													<v-icon>mdi-dots-vertical</v-icon>
												</v-btn>
											</template>
											<v-list>
												<v-list-item>
													<v-list-item-title>Нове авто</v-list-item-title>
													<v-list-item-action>
														<v-checkbox v-model="item.isNew" @change="onBrandIsNew(item)"></v-checkbox>
													</v-list-item-action>
													
												</v-list-item>
											</v-list>
										</v-menu>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="3">
				<v-card :loading="loading.model" class="d-flex flex-column" max-height="85vh">
					<!-- <v-toolbar flat>
						<v-toolbar-title>Моделі</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn>
					</v-toolbar> -->
					<v-toolbar flat :extended="search.model.visible">
						<v-toolbar-title>Моделі</v-toolbar-title>
						<v-spacer></v-spacer>
						<v-btn icon @click="search.model.visible = !search.model.visible">
							<v-icon>mdi-magnify</v-icon>
						</v-btn>
						<!-- <v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn> -->

						<template v-slot:extension v-if="search.model.visible">
							<v-text-field v-model="search.model.text"
								hide-details
								single-line
								clearable
							></v-text-field>
							<!-- prepend-icon="mdi-magnify" -->
						</template>
					</v-toolbar>
					<v-card-text class="flex-grow-1 overflow-y-auto">
						<v-list>
							<v-list-item-group v-model="model" active-class="pink--text">
								<v-list-item v-for="(item, index) in filteredModels" :key="index" @click="onModel(item)">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<v-list-item-subtitle>{{ item.yearFrom }} - {{ item.yearTo }}
											<v-chip v-if="item.isNew"
												class="ma-2"
												color="green"
												text-color="white"
												label
												x-small
											>
											New
											</v-chip>
										</v-list-item-subtitle>
									</v-list-item-content>
									<v-list-item-action>
										<v-menu offset-y>
											<template v-slot:activator="{ on, attrs }">
												<v-btn icon v-bind="attrs" v-on="on">
													<v-icon>mdi-dots-vertical</v-icon>
												</v-btn>
											</template>
											<v-list>
												<v-list-item>
													<v-list-item-title>Нове авто</v-list-item-title>
													<v-list-item-action>
														<v-checkbox v-model="item.isNew" @change="onModelIsNew(item)"></v-checkbox>
													</v-list-item-action>
													
												</v-list-item>
											</v-list>
										</v-menu>
									</v-list-item-action>
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="2">
				<v-card :loading="loading.generation" class="d-flex flex-column" max-height="85vh">
					<v-toolbar flat>
						<v-toolbar-title>Покоління</v-toolbar-title>
						<v-spacer></v-spacer>
						<!-- <v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn> -->
					</v-toolbar>
					<v-card-text class="flex-grow-1 overflow-y-auto">
						<v-list>
							<v-list-item-group v-model="generation" active-class="pink--text">
								<v-list-item v-for="(item, index) in generations" :key="index" @click="onGeneration(item)">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<v-list-item-subtitle>{{ item.yearFrom }} - {{ item.yearTo }}</v-list-item-subtitle>
									</v-list-item-content>

									<!-- <v-list-item-action>
										<v-btn icon>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</v-list-item-action> -->
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
			<v-col cols="12" md="2">
				<v-card :loading="loading.modification" class="d-flex flex-column" max-height="85vh">
					<v-toolbar flat>
						<v-toolbar-title>Модифікація</v-toolbar-title>
						<v-spacer></v-spacer>
						<!-- <v-btn icon>
							<v-icon>mdi-plus</v-icon>
						</v-btn> -->
					</v-toolbar>
					<v-card-text class="flex-grow-1 overflow-y-auto">
						<v-list>
							<v-list-item-group v-model="modification" active-class="pink--text">
								<v-list-item v-for="(item, index) in modifications" :key="index">
									<!-- <v-list-item-avatar>
										<v-icon v-if="item.code=='CAR'">mdi-car-side</v-icon>
										<v-icon v-else-if="item.code=='TRUCK'">mdi-truck</v-icon>
										<v-icon v-else>mdi-car</v-icon>
									</v-list-item-avatar> -->

									<v-list-item-content>
										<v-list-item-title v-text="item.name"></v-list-item-title>
										<!-- <v-list-item-subtitle v-text="item.subtitle"></v-list-item-subtitle> -->
									</v-list-item-content>

									<!-- <v-list-item-action>
										<v-btn icon>
											<v-icon>mdi-dots-vertical</v-icon>
										</v-btn>
									</v-list-item-action> -->
								</v-list-item>
							</v-list-item-group>
						</v-list>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import downloadExcel from "vue-json-excel"
import zVehicleParameters from '@/views/forms/vehicle.parameters.ai'
import zDetail from '@/views/dialogs/details/VehiclePark2'
import zDialogEstimate from '@/views/dialogs/VehicleParkEstimate'
import zConfirmDelete from '@/views/components/dialogs/ConfirmDelete'

export default {
	name: 'VehicleBrandModel',
	//mixins: [mixin],
	components: {
		zVehicleParameters,
		downloadExcel,
		zDetail, zDialogEstimate,
		zConfirmDelete,
	},
	data: () => ({
		title: 'Марки та моделі',
		subtitle: 'Систематизований перелік виробників (марок) та модельних рядів транспортних засобів',
		icon: 'mdi-car-side',
		color: 'green darken-1',
		loading: false,

		search: {
			brand: {
				visible: false,
				text: '',
			},
			model: {
				visible: false,
				text: '',
			},
			generation: {
				visible: false,
				text: '',
			},
			modification: {
				visible: false,
				text: '',
			},
		},

		loading: {
			category: false,
			brand: false,
			model: false,
			generation: false,
			modification: false,
		},

		category: {},
		brand: {},
		model: {},
		generation: {},
		modification: {},

		categories: [],
		brands: [],
		models: [],
		generations: [],
		modifications: [],
	}),
	
	computed: {
		//...mapGetters('VehiclePark', [ 'items' ]),

		filteredBrands() {
			if (!this.search.brand.text) {
				return this.brands;
			}
			return this.brands.filter(item =>
				item.name.toLowerCase().includes(this.search.brand.text.toLowerCase())
			);
		},

		filteredModels() {
			if (!this.search.model.text) {
				return this.models;
			}
			return this.models.filter(item =>
				item.name.toLowerCase().includes(this.search.model.text.toLowerCase())
			);
		},
	},

	created () {
		this.loadCategories()
	},

	methods: {
		//...mapActions(['showMessage']),
		//...mapActions('VehiclePark', [ 'search', 'delete' ]),

		/* onRefresh() {
			this.loading = true
			return this.search().finally(() => (this.loading = false));
		}, */

		/* clearBrand () {
			this.$set(this.item, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			//this.$set(this.item, 'model', null)
			//this.setModels()
			
			this.clearGeneration()
		},

		clearGeneration () {
			this.$set(this.item, 'generation', null)
			this.setGenerations()
			
			this.clearModification()
		},

		clearYearProd() {
			this.$set(this.item, 'yearProd', null)
			this.minYear = 1900
			this.maxYear = (new Date()).getFullYear()
		},

		clearModification () {
			this.$set(this.item, 'modification', null)
			this.setModifications()
		}, */

		//--------------------------------------------------------------------
		onCategory(item) {
			this.loadBrands(item);
		},

		// Завантаження категорій
		loadCategories() {
			var that = this
			this.loading.category = true
			axios.get('/vehicle/category').then(response => {
				//console.log(that.$options.name, 'loadCategories','response.data', response.data)
				that.categories = response.data.filter((element) => ['CAR','TRUCK'].includes(element.code))
				that.brands = []
				that.models = []
				that.generations = []
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.category = false));
		},

		//--------------------------------------------------------------------

		onBrand(item) {
			//console.log(this.$options.name, 'onBrand','item', item)
			//console.log(this.$options.name, 'onBrand','category', this.category)
			this.loadModels(this.categories[this.category], item);
		},

		// Завантаження брендів
		loadBrands(category) {
			var that = this
			this.loading.brand = true
			axios.get(`/vehicle/category/${category.id}/brand`).then(response => {
				//console.log(that.$options.name, 'GetBrands','response.data', response.data)
				that.brands = response.data
				that.models = []
				that.generations = []
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.brand = false));
		},

		//--------------------------------------------------------------------

		onModel(item) {
			//console.log(this.$options.name, 'onModel','item', item)
			this.loadGenerations(item);
		},

		// Завантаження моделей
		loadModels(category, brand) {
			//console.log(this.$options.name, 'loadModels','category', category)

			var that = this
			this.loading.model = true
			axios.get(`/vehicle/category/${category.id}/brand/${brand.id}/models`).then(response => {
				//console.log(that.$options.name, 'loadModels','response.data', response.data)
				that.models = response.data
				that.generations = []
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.model = false));
		},

		//--------------------------------------------------------------------

		onGeneration(item) {
			//console.log(this.$options.name, 'onGeneration','item', item)
			this.loadModifications(item);
		},

		// Завантаження поколінь
		loadGenerations(model) {
			var that = this
			this.loading.generation = true
			axios.get(`/vehicle/model/${model.id}/generation`).then(response => {
				//console.log(that.$options.name, 'loadGenerations','response.data', response.data)
				that.generations = response.data
				that.modifications = []
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.generation = false));
		},

		//--------------------------------------------------------------------

		/* onModification(item) {
			console.log(this.$options.name, 'onModification','item', item)
			loadBrands(item);
		}, */

		// Завантаження модифікацій
		loadModifications(generation) {
			var that = this
			this.loading.modification = true
			axios.get(`/vehicle/generation/${generation.id}/modification`).then(response => {
				//console.log(that.$options.name, 'loadModifications','response.data', response.data)
				that.modifications = response.data
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.modification = false));
		},

		//--------------------------------------------------------------------

		// Зміна значення ознаки моделі Нове авто
		onBrandIsNew(item) {
			var that = this
			this.loading.brand = true
			axios.put(`/vehicle/brand/${item.id}`, { isNew: item.isNew }).then(response => {
				//console.log(that.$options.name, 'onModelIsNew','response.data', response.data)
				const index = that.brands.indexOf(item)
				that.brands.splice(index, 1, response.data)
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.brand = false));
		},

		// Зміна значення ознаки моделі Нове авто
		onModelIsNew(item) {
			var that = this
			this.loading.model = true
			axios.put(`/vehicle/model/${item.id}`, { isNew: item.isNew }).then(response => {
				//console.log(that.$options.name, 'onModelIsNew','response.data', response.data)
				const index = that.models.indexOf(item)
				that.models.splice(index, 1, response.data)
			}, error => {
				console.log('error', error)
			}).finally(() => (this.loading.model = false));
		},
	},
}
</script>